function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.75 7.75H3.925L8.463 2.3A1.252 1.252 0 006.538.7L.287 8.2c-.043.06-.08.122-.113.187 0 .063 0 .1-.087.163A1.25 1.25 0 000 9c.001.154.03.307.088.45 0 .062 0 .1.087.162.033.066.07.128.112.188l6.25 7.5a1.249 1.249 0 00.963.45 1.25 1.25 0 00.963-2.05l-4.538-5.45H18.75a1.25 1.25 0 100-2.5z",
  fill: "#B4C0CF"
});

var SvgBespokenLeftArrow = function SvgBespokenLeftArrow(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenLeftArrow;